const Error = () => {
  return <div className="spinner-container">Error - Page Not Found</div>;
};

export default Error;
